import * as React from 'react';
import Button from 'src/components/common/Button';
import './RegisterView.scss';
import { goToLogin, loginUrl } from 'src/utils/navigation';
import env from 'src/shared/env';

interface IRegisterViewProps {
  t?: any;
}

function downloadForm() {
  window.open(
    `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/credit-app-usa.pdf`,
    '_blank'
  );
}

function downloadEnglishFormCA() {
  window.open(
    `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/credit-app-ca-english.pdf`,
    '_blank'
  );
}

function downloadFrenchFormCA() {
  window.open(
    `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/credit-app-ca-french.pdf`,
    '_blank'
  );
}

function renderUSVersion(t: any) {
  return (
    <div className="rp-register-view">
      <div className="rp-register-view--card">
        <div className="rp-register-view--section">
          <h1 className="h1">{t('login.applyForAccount')} </h1>
        </div>
        <div className="rp-register-view--section">
          <p>{t('login.requestTxt')}</p>
          <p>
            <b>{t('common.email')}: newaccounts@reliableparts.com</b>
          </p>
          <p>
            <b>or</b>
          </p>
          <p>
            <b>{t('common.fax')}: 214-905-2057</b>
          </p>
        </div>
        <div className="rp-register-view--button-container rp-register-view--section">
          <Button
            buttonClass="primary-button rp-register-view--download-form"
            height="64px"
            width="280px"
            action={downloadForm}
          >
            <i className="rpds-get-app" /> {t('login.downloadForm')}
          </Button>
        </div>
        <div className="rp-register-view--section">
          <p>{t('login.requestAdditionalTxt')}</p>
          <a
            href={`${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/Wayfair_Letter.docx`}
            className="rp-download"
          >
            Download Wayfair Letter
          </a>
        </div>

        <div className="rp-register-view--section">
          <p>
            <b>{t('login.resaleCertificates')}:</b>
          </p>
        </div>

        <div className="rp-register-view--section rp-register-view--list--container">
          <div className="rp-register-view--list">
            <div className="row">
              <div className="col-6 col-md-3 col-md-val">
              <div className="rp-accountinfo--item-title"> 
                <a
                  target="_blank"
                  href={`${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/Indiana_ST-105_Certificate.pdf`}
                >
                  Indiana
                </a></div>
              </div>
              <div className="col-6 col-md-3 col-md-val">
                <div className="rp-accountinfo--item-title"> 
                  <a
                  target="_blank"
                  href={`${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/Lousiana_R-1042_Certificate.pdf`}
                >
                  Lousiana
                </a></div></div>
                <div className="col-6 col-md-3 col-md-val"><div className="rp-accountinfo--item-title">
                  <a
                  target="_blank"
                  href={`${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/Mississippi_Tax_Certificate.pdf`}
                >
                  Mississippi
                </a></div></div>
                <div className="col-6 col-md-3 col-md-val"><div className="rp-accountinfo--item-title"> 
                  <a
                  target="_blank"
                  href={`${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/New_York_ST-120_Certificate.pdf`}
                >
                  New York
                </a></div></div>
                <div className="col-6 col-md-3 col-md-val"><div className="rp-accountinfo--item-title ready_pickup">
                  <a
                  target="_blank"
                  href={`${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/Virginia_ST-10_Certificate.pdf`}
                >
                  Virginia
                </a> </div></div>
                <div className="col-6 col-md-3 col-md-val"><div className="rp-accountinfo--item-title ready_pickup">
                  <a
                  target="_blank"
                  href={`${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/West_Virginia_Tax_Certificate.pdf`}
                >
                  West Virginia
                </a> </div></div>
                <div className="col-6 col-md-3 col-md-val"><div className="rp-accountinfo--item-title ready_pickup">
                  <a
                  target="_blank"
                  href={`${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/Wyoming_Tax_Certificate.pdf`}
                >
                  Wyoming
                </a> </div></div>
                <div className="col-6 col-md-3 col-md-val"><div className="rp-accountinfo--item-title ready_pickup">
                  <a
                  target="_blank"
                  href={`${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/Uniform-Sales-and-Use-Certificate-5_21_2019.pdf`}
                >
                  Uniform Sales Form
                </a></div></div>
            </div>
          </div>
        </div>

        <span className="rp-register-view--separator" />

        <h1 className="h1">{t('login.alreadyCustomer')}</h1>
        <a
          href={loginUrl()}
          className="rp-register-view--register--link"
          onClick={goToLogin}
        >
          {t('login.loginInHere')}
        </a>
      </div>
    </div>
  );
}

function renderCAVersion(t: any) {
  return (
    <div className="rp-register-view">
      <div className="rp-register-view--card">
        <div className="rp-register-view--section">
          <h1 className="h1">{t('login.applyForAccount')}</h1>
        </div>
        <div className="rp-register-view--section">
          <p>{t('login.requestTxt')}</p>
          <p>
            <b>{t('common.email')}: reliablepartsar1@reliableparts.com</b>
          </p>
          <p>
            <b>or</b>
          </p>
          <p>
            <b>{t('common.tollFreeFax')} 1 604 944 0967</b>
          </p>
        </div>
        <div className="rp-register-view--button-container rp-register-view--section">
          <Button
            buttonClass="primary-button rp-register-view--download-form"
            height="64px"
            width="280px"
            action={downloadEnglishFormCA}
          >
            <i className="rpds-get-app" /> {t('login.downloadEnglishForm')}
          </Button>
        </div>
        <div className="rp-register-view--button-container rp-register-view--section">
          <Button
            buttonClass="primary-button rp-register-view--download-form"
            height="64px"
            width="280px"
            action={downloadFrenchFormCA}
          >
            <i className="rpds-get-app" /> {t('login.downloadFrenchForm')}
          </Button>
        </div>

        <span className="rp-register-view--separator" />

        <h1 className="h1">{t('login.alreadyCustomer')}</h1>
        <a
          href={loginUrl()}
          className="rp-register-view--register--link"
          onClick={goToLogin}
        >
          {t('login.loginInHere')}
        </a>
      </div>
    </div>
  );
}

export function RegisterView(props: IRegisterViewProps) {
  const { t } = props;
  return env.REACT_APP_BASE_ENVIRONMENT === 'CA'
    ? renderCAVersion(t)
    : renderUSVersion(t);
}
